import React from 'react';
import { SynchronizationReportCard } from './SynchronizationReportCard';

export function SynchronizationReport({ data,  translations })
{
    if (!data) { return <div></div>; }
    const dataKeySet = new Set(Object.keys(data));
    const dataKeys = [];
    const keysOrder = ['Summary', 'RequestParameters', 'RuntimeParameters', 'Configuration'];
    const keysOrderSet = new Set(keysOrder);

    for (const key of keysOrder)
    {
        if (dataKeySet.has(key)) { dataKeys.push(key); }
    }

    for (const [key] of Object.entries(data))
    {
        if (keysOrderSet.has(key) === false) { dataKeys.push(key); }
    }

    const cardItems = dataKeys.map(key => ({ key, value: data[key] }));
    const element =
    <div>
        {cardItems.filter(({ value }) => Array.isArray(value) === false).map(({ key, value }) => <SynchronizationReportCard key={key} title={key} value={value} translations={translations} />)}
        {cardItems.filter(({ value }) => Array.isArray(value)).map(({ key, value }) => <SynchronizationReportCard key={key} title={key} value={value} translations={translations} />)}
    </div>;
    return element;
}